import {Elements} from '@stripe/react-stripe-js'
import {StripeElementsOptions, loadStripe} from '@stripe/stripe-js'
import cx from 'classnames'
import {OrderProvider} from 'providers/OrderProvider'
import {Ventrata} from 'types'
import {getActualStripeIntent} from 'utils/getStripePaymentIntent'
import {AdyenForm} from './AdyenForm'
import {Contact} from './Contact'
import {StripeForm} from './StripeForm'
import {appearance} from './appearance'

type Props = {
  ready: boolean
  onReady: () => void
}

export const View = ({ready, onReady}: Props) => {
  const order = OrderProvider.useOrder()

  if (!order.cardPayment) {
    throw new Error(`Card payment is not defined`)
  }

  if (order.cardPayment.gateway === 'stripe') {
    return <ViewStripeGateway ready={ready} onReady={onReady} order={order} />
  }

  if (order.cardPayment.gateway === 'adyen') {
    return <ViewAdyenGateway ready={ready} onReady={onReady} order={order} />
  }

  return null
}

const ViewStripeGateway = ({ready, onReady, order}: Props & {order: Ventrata.Order}) => {
  const stripeIntent = getActualStripeIntent(order)
  const stripePromise = loadStripe(stripeIntent.publishableKey)

  const options: StripeElementsOptions = {
    clientSecret: stripeIntent.clientSecret,
    appearance,
    loader: 'never',
  }

  return (
    <div className={cx('flex flex-col gap-6', ready ? 'visible' : 'invisible')}>
      <Contact />
      <div className="flex flex-col gap-2">
        <p>Please enter your card information to reserve your spot on the tour.</p>
      </div>

      <Elements key={stripeIntent.id} stripe={stripePromise} options={options}>
        <StripeForm onReady={onReady} stripeIntent={stripeIntent} />
      </Elements>
    </div>
  )
}

const ViewAdyenGateway = ({ready, onReady, order}: Props & {order: Ventrata.Order}) => {
  return (
    <div className="flex flex-col gap-6">
      <Contact />

      <div className="flex flex-col gap-2">
        <p>Please enter your card information to reserve your spot on the tour.</p>
      </div>

      <div>
        <AdyenForm onReady={onReady} />
      </div>
    </div>
  )
}
